import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { CustomerService } from '@fi-app/customer-billing/customer-billing-customer/customer.service';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { fiBasicUsageChargeTypes } from '@fi-app/customer-billing/customer-billing-customer/basic-usage-charge-type';
import { fiPaymentMethodTypes } from '@fi-app/customer-billing/payment-method-type';
import { fiCustomerPaymentStatusesShortTextId } from '@fi-app/customer-billing/customer-billing-customer/customer-payment-status';
import { VATs } from '../../../customer-billing-components/VAT';
import { CustomerBillingOtherCustomerModel } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer.model';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-customer-billing-customer-edit-payment-information',
    templateUrl: './customer-billing-customer-edit-payment-information.component.html',
    styleUrls: ['./customer-billing-customer-edit-payment-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-edit-payment-information' },
    providers: [
        { provide: FiComponentsContainer, useExisting: CustomerBillingCustomerEditPaymentInformationComponent },
    ],
    standalone: false,
})
export class CustomerBillingCustomerEditPaymentInformationComponent extends FiComponentsContainer {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() resellerListData: DropdownSettingsModelV2<CustomerBillingOtherCustomerModel>;
    @Input() contractLengthListData: DropdownSettingsModelV2<INameIdObj>;
    @Input() lowestUnitLevelChargeListData: DropdownSettingsModelV2<INameIdObj>;

    selectContractPeriodSettings = {
        StartTimeProperty: 'ContractStartTime',
        EndTimeProperty: 'ContractEndTime',
    };
    fiBasicUsageChargeTypes = fiBasicUsageChargeTypes;
    paymentMethods = fiPaymentMethodTypes;
    paymentStatuses = fiCustomerPaymentStatusesShortTextId;
    VATs = VATs;

    constructor(private customerService: CustomerService) {
        super();
    }

    getShutOffDateClass(): string {
        return this.customerService.getShutOffDateClass(this.customer);
    }
}
